import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { PageAction } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { isEmpty } from "lodash-es";
import { combineLatest } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";

import { GameSelector } from "../game/game.selector";
import { GameCollectionSelector } from "../game-collection/game-collection.selector";
import { GamingExternalState } from "../state";

import { GamingRouteService } from "./gaming-route.service";

@Injectable()
export class GamingRouteEffect {
	getGamingDocumentKey$ = createEffect(() =>
		this.actions$.pipe(
			ofType(RouteAction.resolveEnd),
			map(({ payload: { current } }) => current),
			filter((route) => route.data && route.data.hasDynamicGamingPageContent),
			switchMap((route) =>
				combineLatest([
					this.store.pipe(
						select(this.gameSelector.getAll()),
						filter((games) => !isEmpty(games)),
						take(1)
					),
					this.store.pipe(
						select(this.gameCollectionSelector.getAll()),
						filter((gameCollection) => !isEmpty(gameCollection)),
						take(1)
					),
				]).pipe(
					map(() => ({
						segment: this.service.getDocumentKeyfromRoute(route),
						parentSegments: this.service.getParentSegments(route),
					}))
				)
			),
			filter((data) => !!data.segment),
			map((data) => PageAction.setByDocumentKey({ segment: data.segment!, parentSegments: data.parentSegments }))
		)
	);

	constructor(
		private store: Store<GamingExternalState>,
		private actions$: Actions,
		private service: GamingRouteService,
		private gameSelector: GameSelector,
		private gameCollectionSelector: GameCollectionSelector
	) {}
}
